<template>
  <div class="mod-inventory-ledger">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.productName" :placeholder="$t('inventoryLedger.productName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.transactionType" :placeholder="$t('inventoryLedger.transactionType')" clearable>
          <el-option :label="$t('inventoryLedger.inbound')" value="INBOUND"></el-option>
          <el-option :label="$t('inventoryLedger.outbound')" value="OUTBOUND"></el-option>
          <el-option :label="$t('inventoryLedger.adjustment')" value="ADJUST"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.referenceType" :placeholder="$t('inventoryLedger.referenceType')" clearable>
          <el-option label="采购" value="PURCHASE"></el-option>
          <el-option :label="$t('inventoryLedger.sale')" value="SALE"></el-option>
          <el-option label="耗用" value="CONSUME"></el-option>
          <el-option :label="$t('inventoryLedger.adjustment')" value="ADJUST"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.operatorName" :placeholder="$t('inventoryLedger.operatorName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dataForm.dateRange"
          type="daterange"
          :range-separator="$t('common.to')"
          :start-placeholder="$t('common.startDate')"
          :end-placeholder="$t('common.endDate')"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('common.query') }}</el-button>
        <el-button type="primary" @click="exportData()">{{ $t('common.export') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%;">
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.transactionId')">
      </el-table-column>
      <el-table-column
        prop="productName"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.productName')">
      </el-table-column>
      <el-table-column
        prop="transactionType"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.transactionType')">
        <template slot-scope="scope">
          <el-tag :type="getTransactionTypeTag(scope.row.transactionType)">
            {{ getTransactionTypeText(scope.row.transactionType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="quantity"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.quantity')">
        <template slot-scope="scope">
          <span :class="getQuantityClass(scope.row.quantity)">
            {{ scope.row.quantity > 0 ? '+' : '' }}{{ scope.row.quantity }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="beforeStock"
        header-align="center"
        align="center"
        :label="$t('inventory.beforeStock')">
      </el-table-column>
      <el-table-column
        prop="afterStock"
        header-align="center"
        align="center"
        :label="$t('inventory.afterStock')">
      </el-table-column>
      <el-table-column
        prop="unitPrice"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.unitPrice')">
        <template slot-scope="scope">
          ¥{{ scope.row.unitPrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="totalAmount"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.totalAmount')">
        <template slot-scope="scope">
          ¥{{ scope.row.totalAmount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="referenceType"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.referenceType')">
      </el-table-column>
      <el-table-column
        prop="referenceId"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.referenceId')">
      </el-table-column>
      <el-table-column
        prop="operatorName"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.operatorName')">
      </el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.remark')">
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        :label="$t('inventoryLedger.createTime')">
        <template slot-scope="scope">
          {{ scope.row.createTime | dateFormat }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dataForm: {
          productName: '',
          transactionType: '',
          referenceType: '',
          operatorName: '',
          dateRange: []
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false
      }
    },
    created () {
      this.getDataList()
    },
    activated () {
      this.getDataList()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        const params = {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'productName': this.dataForm.productName,
          'transactionType': this.dataForm.transactionType,
          'referenceType': this.dataForm.referenceType,
          'operatorName': this.dataForm.operatorName
        }
        
        if (this.dataForm.dateRange && this.dataForm.dateRange.length === 2) {
          params.startTime = this.dataForm.dateRange[0]
          params.endTime = this.dataForm.dateRange[1]
        }
        
        this.$http({
          url: 'inventory/ledger/page',
          method: 'get',
          params: params
        }).then(({data}) => {
          console.log('Stock ledger response:', data)
          if (data && data.code === 0) {
            this.dataList = data.data.list || []
            this.totalPage = data.data.total || 0
            console.log('Loaded stock ledger entries:', this.dataList.length)
          } else {
            console.log('No data or error:', data)
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        }).catch(error => {
          console.error('Stock ledger error:', error)
          this.dataList = []
          this.totalPage = 0
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 导出数据
      exportData () {
        const params = {
          'productName': this.dataForm.productName,
          'transactionType': this.dataForm.transactionType,
          'referenceType': this.dataForm.referenceType,
          'operatorName': this.dataForm.operatorName
        }
        
        if (this.dataForm.dateRange && this.dataForm.dateRange.length === 2) {
          params.startTime = this.dataForm.dateRange[0]
          params.endTime = this.dataForm.dateRange[1]
        }
        
        this.$http({
          url: 'inventory/ledger/export',
          method: 'get',
          params: params,
          responseType: 'blob'
        }).then(({data}) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '库存台账.xlsx'
          link.click()
          window.URL.revokeObjectURL(url)
        })
      },
      // 获取交易类型标签
      getTransactionTypeTag (type) {
        const tagMap = {
          'INBOUND': 'success',
          'OUTBOUND': 'danger',
          'ADJUST': 'warning'
        }
        return tagMap[type] || 'info'
      },
      // 获取交易类型文本
      getTransactionTypeText (type) {
        const textMap = {
          'INBOUND': '入库',
          'OUTBOUND': '出库',
          'ADJUST': '调整'
        }
        return textMap[type] || type
      },
      // 获取数量样式类
      getQuantityClass (quantity) {
        if (quantity > 0) {
          return 'text-success'
        } else if (quantity < 0) {
          return 'text-danger'
        }
        return ''
      }
    }
  }
</script>

<style scoped>
  .text-success {
    color: #67c23a;
    font-weight: bold;
  }
  .text-danger {
    color: #f56c6c;
    font-weight: bold;
  }
</style>
